
import { defineComponent, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { default as PostModel, ProPost } from '../../models/proPost.model';
import { default as PostCategoriesModel } from '../../models/proPostCategories.model';
import FileUpload from '../../components/ui/FileUpload.vue';
import SubmitButton from '../../components/ui/SubmitButton.vue';
import dateTimeHelper from '../../helper/datetime.helper';
import Editor from '../../components/ui/Editor.vue';
import swal from '../../helper/swal.helper';

export default defineComponent({
  components: {
    FileUpload,
    SubmitButton,
    Editor,
  },
  setup() {
    const router = useRouter();
    let thumbnailFile = ref<any>(null);
    let customEditor = ref<any>(null);
    let loading = ref(false);
    let isSubmitting = ref(false);
    let categories = ref([]);
    let post = ref<ProPost>({
      title: '',
      category_id: '',
      published_at: 0,
      pin: false,
      show: false,
      landing_url: '',
      contents_url: '',
      desc: '',
      thumbnail: '',
      created_at: 0,
      updated_at: 0,
      order: 0,
      view_count: 0,
      show_view_count: false,
      no_margin_layout: false,
    });
    let publishTime = ref<string>('');

    let postId = router.currentRoute.value.params.id;
    let setPreviewImg = ref('');
    onMounted(async () => {
      loading.value = true;
      post.value = await PostModel.findById(postId);
      publishTime.value = dateTimeHelper.timestampMilisToDateTimeInput(
        post.value.published_at,
      );
      categories.value = await PostCategoriesModel.getAll();
      setPreviewImg.value = post.value.thumbnail;
      loading.value = false;
    });

    async function submitForm() {
      isSubmitting.value = true;

      let thumbnail = await thumbnailFile.value?.uploadImage();
      if (thumbnail.length <= 0) {
        thumbnail = post.value.thumbnail;
      }
      let data = {
        category_id: post.value.category_id,
        created_at: new Date(),
        desc: await customEditor.value?.getContents(),
        pin: post.value.pin,
        landing_url: post.value.landing_url,
        contents_url: post.value.contents_url,
        published_at: publishTime.value
          ? dateTimeHelper.dateToTimestamp(publishTime.value)
          : 0,
        show: post.value.show,
        thumbnail: thumbnail,
        title: post.value.title,
        order: post.value.order,
        show_view_count: post.value.show_view_count,
        no_margin_layout: post.value.no_margin_layout,
      };
      let updateResult = await PostModel.update(postId, data);
      if (updateResult.status) {
        isSubmitting.value = false;
        router.push('/pro-post');
      } else {
        isSubmitting.value = false;
        swal.alert(updateResult.message);
      }
    }

    return {
      post,
      thumbnailFile,
      submitForm,
      categories,
      loading,
      isSubmitting,
      setPreviewImg,
      publishTime,
      customEditor,
    };
  },
});
